module.exports = __webpack_public_path__ + "static/media/laugh-beam.2f81bffc.svg";